// eslint-disable-next-line unicorn/prefer-module
const imagesContext = require.context("./photos", false, /\.(jpg|jpeg|png)$/);

const parseImageData = (filePath) => {
  const fileName = filePath.split("/").pop().split(".")[0]; // Ej: "514-111-asc"
  const [potentialIdCliente, potentialIdEdificio, potentialScreenType] = fileName.split("-");
  const idcliente = parseInt(potentialIdCliente);
  const idedificio = parseInt(potentialIdEdificio);
  const screenType = potentialScreenType || null;
  return {
    src: imagesContext(filePath),
    alt: fileName,
    idcliente: !isNaN(idcliente) ? idcliente : null,
    idedificio: !isNaN(idedificio) ? idedificio : null,
    screenType: screenType ? screenType.toLowerCase() : null,
    tags: [],
  };
};

export const photosData = imagesContext.keys().map((filePath) => parseImageData(filePath));
